import { useIsModuleEnabled } from "src/hooks/useIsModuleEnabled";

export const useIsAgentsEnabled = (): {
  isEnabled: boolean;
} => {
  return useIsModuleEnabled("agents");
};
